import React from 'react';
import image from '../../../Assets/Cards/Frame.webp';
import  Google from '../../../Assets/Icons/iphone2.svg';
import AppPart from '../../Shared/AppPart/AppPart';

const Frame=()=>{
    return(
        <>
        <AppPart 
        title="Turn anything into interactive prototypes"
        desc="Our apps let you create, play and share on the go."
        backgroundImage1 = {Google}
   
        image={image}
        />
        </>
    )
};
export default Frame ;